import { Component } from '@angular/core';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { Router } from '@angular/router';
import { PopoverController } from '@ionic/angular';
import { MatSnackBar } from '@angular/material/snack-bar';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';

enum Language {
	GreatBritain = 'en',
	German = 'de',
}
@Component({
	selector: 'app-menu-popover',
	templateUrl: './menu-popover.component.html',
	styleUrls: ['menu-popover.component.scss'],
})
export class MenuPopoverComponent extends RepositoryDirective {
	environment = environment;
	languageEnum = Language;
	constructor(
		public repository: RepositoryService,
		private router: Router,
		private popoverCtrl: PopoverController,
		private snackbarCtrl: MatSnackBar,
		public translate: TranslateService,
		private navigationService: NavigationService
	) {
		super(repository);
	}

	async signIn() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.signIn();
	}

	async signUp() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.signUp();
	}

	async mySpace() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.account();
	}

	async myOrders() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.myOrders();
	}

	async logout() {
		try {
			this.repository.customerAuth.emit(null);
			this.repository.obserableOrder.next(null);
			this.repository.previousPreorder.emit(null);
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_success'), null, {
				duration: 2000,
			});
		} catch (e) {
			this.snackbarCtrl.open(this.translate.instant('menu_popover.logout_error'), null, {
				duration: 2000,
			});
		}
		await this.popoverCtrl.dismiss();
	}

	async home() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.home();
	}

	async privacy() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.privacy();
	}

	async tos() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.tos();
	}

	async impressum() {
		await this.popoverCtrl.dismiss();
		await this.navigationService.imprint();
	}

	dismiss() {
		this.popoverCtrl.dismiss();
	}
	changeLang(language: string) {
		this.translate.setDefaultLang(language);
		this.translate.use(language);
	}
}
